import React from "react";
import { Card, Row, Col, Container } from "react-bootstrap";
import { Link } from "react-router-dom";
import Slider from "react-slick";
import { motion } from "framer-motion";
import { BASE_URL } from "../../constants";

// reverted assets
const IndustryLeaders = () => {
  const settings = {
    autoplay: true,
    autoplaySpeed: 4000,
    dots: true,
    arrows: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    infinite: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  // Card data with links
  const cards = [
    {
      id: 1,
      image: "solutions/climate.png",
      title: "Climate Tech Innovators",
      description:
        "The path to a Net Zero future is driven by innovation, and climate tech pioneers are at the forefront of this transformation....",
      link: "/climate-tech",
    },
    {
      id: 2,
      image: "solutions/company.png",
      title: "Industrial Companies",
      description:
        "Industrial companies face increasing pressure to reduce emissions, optimize operations, and meet sustainability goals....",
      link: "/industrial-companies",
    },
    {
      id: 3,
      image: "solutions/persons.png",
      title: "Engineering & Consulting Companies",
      description:
        "Engineering and consulting firms play a critical role in guiding industries toward efficiency, sustainability, and innovation....",
      link: "/engineering-companies",
    },
    {
      id: 4,
      image: "solutions/government_agencies.png",
      title: "Government Agencies",
      description:
        "Government agencies play a crucial role in shaping climate policies, enforcing regulations, and supporting industries in the transition....",
      link: "/government-agencies",
    },
    {
      id: 5,
      image: "solutions/financials.png",
      title: "Financial Institutions",
      description:
        "As the world moves toward a more sustainable and resilient future, financial institutions play a critical role in funding impactful....",
      link: "/financial-institutions",
    },
  ];

  // Animation variants for Framer Motion
  const cardVariants = {
    offscreen: {
      y: 50,
      opacity: 0,
    },
    onscreen: {
      y: 0,
      opacity: 1,
      transition: {
        type: "spring",
        bounce: 0.4,
        duration: 0.8,
      },
    },
  };

  // Hover animation for images
  const imageHoverVariants = {
    hover: {
      scale: 1.05,
      transition: {
        type: "spring",
        stiffness: 300,
      },
    },
  };

  // Animation for the entire slider container
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.3, // Delay between each card's animation
      },
    },
  };

  return (
    <Container>
      {/* Heading Section */}
      <Row className="justify-content-center text-center mb-4">
        <Col>
          <div className="main-heading">
            Tailored for
            <br />
            Industry Leaders
          </div>

          <p className="sub-heading">
            Dsider supports diverse organizations in their energy transition
            journey
          </p>
        </Col>
      </Row>

      {/* Card Section */}
      <motion.div
        initial="hidden"
        animate="visible"
        variants={containerVariants}
      >
        <Slider {...settings}>
          {cards.map((card) => (
            <motion.div
              key={card.id}
              variants={cardVariants}
              initial="offscreen"
              whileInView="onscreen"
              viewport={{ once: true, amount: 0.5 }}
            >
              {/* Wrap the card in a Link */}
              <Link
                to={card.link}
                style={{ textDecoration: "none", color: "inherit" }}
              >
                <Card className="custom-card">
                  <Row className="g-0 align-items-center">
                    {/* Image Column for mobile */}
                    <Col xs={4} className="d-block d-md-none">
                      <motion.div
                        whileHover="hover"
                        variants={imageHoverVariants}
                      >
                        <Card.Img
                          src={`${BASE_URL}${card.image}`}
                          alt={card.title}
                          style={{
                            width: "100%",
                            height: "150px",
                            objectFit: "cover",
                            borderRadius: "10px",
                          }}
                        />
                      </motion.div>
                    </Col>

                    {/* Text Column */}
                    <Col xs={8} md={12}>
                      <Card.Body>
                        <p className="cardHeading">{card.title}</p>
                        <Card.Text>{card.description}</Card.Text>
                      </Card.Body>
                    </Col>

                    {/* Image for larger screens */}
                    <Col xs={12} className="d-none d-md-block">
                      <motion.div
                        whileHover="hover"
                        variants={imageHoverVariants}
                      >
                        <motion.img
                          src={`${BASE_URL}${card.image}`}
                          alt={card.title}
                          style={{
                            width: "340px",
                            height: "200px",
                            objectFit: "cover",
                            borderRadius: "0rem",
                          }}
                        />
                      </motion.div>
                    </Col>
                  </Row>
                </Card>
              </Link>
            </motion.div>
          ))}
        </Slider>
      </motion.div>
    </Container>
  );
};

export default IndustryLeaders;
